import { Stack, Typography } from "@mui/material";

interface CustomProps {
  title: JSX.Element | string;
}

const SuggestionBox = (props: CustomProps) => {
  return (
    <Stack p={1} sx={{ backgroundColor: "#f4f1fc", borderRadius: "8px" }}>
      <Typography variant="body2">{props.title}</Typography>
    </Stack>
  );
};

export default SuggestionBox;
